import { PdfImportTracker } from "@/components/pdfImport/PdfImportTracker";
import { NotFound } from "@/components/shared/NotFound";
import { PdfImportProvider } from "@/contexts/PdfImportContext";
import { Outlet, createRootRoute } from "@tanstack/react-router";
import type React from "react";

function RootComponent(): React.JSX.Element {
  return (
    <div className="min-h-screen bg-background">
      <PdfImportProvider>
        <main id="main-content">
          <Outlet />
        </main>
        <PdfImportTracker />
      </PdfImportProvider>
    </div>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFound,
});
